import { AppLayout } from "@amzn/awsui-components-react";
import React, { useEffect, useState } from "react";
import CargoClaimIntakeApp from "src/app/Cargo/CargoClaimIntakeApp";
import { PAGE_TITLES } from "src/app/constants";
import SideMenu from "src/components/sideMenu/SideMenu";

function CargoClaimIntakePage() {
  const [navigationOpen, setNavigationOpen] = useState(true);

  /**
   * Changes the browser tab/menu bar title to Claim Intake Form when page loads
   */
  useEffect(() => {
    document.title = PAGE_TITLES.CARGO_CLAIM_INTAKE_FORM;
  }, []);

  return (
    <AppLayout
      content={<CargoClaimIntakeApp></CargoClaimIntakeApp>}
      navigation={<SideMenu />}
      navigationOpen={navigationOpen}
      onNavigationChange={({ detail }) => setNavigationOpen(detail.open)}
      ariaLabels={{
        navigationClose: "Close side menu",
        navigationToggle: "Open Side menu",
      }}
      toolsHide={true}
      contentType="wizard"
      footerSelector="#app-footer"
      headerSelector="#app-header"
    />
  );
}

export default CargoClaimIntakePage;
